import { getBytes, getMetadata, ref } from 'firebase/storage';
import { storage } from '../../firebase';

// Legacy URLs also use authenticated SDK access, never a bearer-token fetch.
export async function loadDocumentFile(item) {
  const location = item?.storagePath || item?.fileUrl;
  if (!location) throw new Error('No uploaded file is available.');
  const file = ref(storage, location);
  if (file.bucket !== storage.app.options.storageBucket || !file.fullPath.startsWith('workerDocuments/')) {
    throw new Error('This document needs to be uploaded again to private document storage.');
  }
  const metadata = await getMetadata(file);
  if (item.storageGeneration && String(metadata.generation) !== String(item.storageGeneration)) {
    throw new Error('Document changed. Refresh the review queue before reviewing.');
  }
  if (!['application/pdf', 'image/png', 'image/jpeg'].includes(metadata.contentType)) {
    throw new Error('Unsupported document type. Upload a PDF, PNG or JPG file.');
  }
  const bytes = await getBytes(file, 10 * 1024 * 1024);
  return new Blob([bytes], { type: metadata.contentType });
}
